import { useMutation } from '@tanstack/react-query';
import { useSettings } from '@wu/widget-core';
import { formatISO } from 'date-fns';
import { APPOINTMENT_BOOKING_API_BASE_URL } from '../../constants/constants';
import type { Timeslot } from '../datetime/datetime-provider';
import { getSessionId } from '../utils/get-session-id';

export function useLockTimeslot() {
  const { widgetToken, widgetId } = useSettings();

  return useMutation({
    mutationFn: async (selectedTimeslot: Timeslot) => {
      if (!selectedTimeslot || !widgetId) {
        return;
      }

      const widgetIdEncoded = encodeURIComponent(widgetId);

      const params = new URLSearchParams({
        from: formatShortISO(selectedTimeslot.from),
        to: formatShortISO(selectedTimeslot.to),
        appointmentId: widgetIdEncoded
      });

      const response = await fetch(
        `${APPOINTMENT_BOOKING_API_BASE_URL}/appointment-booking/timeslot/lock?${params}`,
        {
          method: 'POST',
          headers: new Headers({
            'x-session-id': getSessionId(),
            'x-widget-token': widgetToken || ''
          })
        }
      );

      if (!response.ok) {
        throw new Error(
          response.status === 409
            ? 'The selected time slot is already taken'
            : 'Unexpected Error'
        );
      }

      const { payload } = (await response.json()) as {
        code: number;
        message?: string;
        payload?: { url: string };
      };

      return payload;
    },
    onError: (e) => {
      console.error(e);
      // @TODO print error for human
    },
    onSuccess: () => {}
  });
}

const formatShortISO = (date: Date) => formatISO(date).replace(/[-:]/g, '');
